module.exports = __webpack_public_path__ + "static/media/RR-VP-2.609d2ce5.jpg";